module.exports = __webpack_public_path__ + "img/17_18.79ec4e9a.png";